import { render, staticRenderFns } from "./PartsDetailsLayer.vue?vue&type=template&id=f015047e&scoped=true&"
import script from "./PartsDetailsLayer.vue?vue&type=script&lang=js&"
export * from "./PartsDetailsLayer.vue?vue&type=script&lang=js&"
import style0 from "./PartsDetailsLayer.vue?vue&type=style&index=0&id=f015047e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f015047e",
  null
  
)

export default component.exports